import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15dc17a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wifi-product-list" }
const _hoisted_2 = ["id", "value"]
const _hoisted_3 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
      return (_openBlock(), _createElementBlock("li", {
        key: product.pro_name_id,
        class: "each-product"
      }, [
        _createElementVNode("input", {
          type: "radio",
          name: "wifi_product_select",
          id: 'id-product-' + product.pro_name_id,
          value: product.pro_name_id,
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
        }, null, 40, _hoisted_2),
        _createElementVNode("label", {
          for: 'id-product-' + product.pro_name_id,
          class: _normalizeClass({ invalid: _ctx.isInvalid })
        }, _toDisplayString(product.pro_name), 11, _hoisted_3)
      ]))
    }), 128))
  ]))
}